module.exports = __webpack_public_path__ + "img/criminal-records-icon.svg";